import { gql } from '@apollo/client';

const schema = {
  get: {
    name: 'attribute',
    serviceName: 'shopadmin',
    query: gql`
      query attribute($ids: [String]) {
        attribute(ids: $ids) {
          data {
            type
            title
            details
            category {
              id
            }
          }
        }
      }
    `,
  },
  update: {
    name: 'updateAttribute',
    serviceName: 'admin',
    query: gql`
      mutation updateAttribute($ids: [String]!, $title: String, $type: String, $details: String, $category_id: String) {
        updateAttribute(ids: $ids, title: $title, type: $type, details: $details, category_id: $category_id) {
          influenced_count
          messages
        }
      }
    `,
  },
};

export default schema;
